import { useEffect, useState, type ReactNode } from "react";
import { useLocation } from "wouter";
import { AuthProvider } from "@/context/AuthContext";
import { getMe, type AuthUser, type Workspace } from "@/lib/auth";

export function AuthGate({ children }: { children: ReactNode }) {
  const [, setLocation] = useLocation();
  const [data, setData] = useState<{ user: AuthUser; workspace: Workspace | null } | null>(null);

  useEffect(() => {
    let cancelled = false;

    getMe()
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch(() => {
        // Any non-200 from /api/auth/me is treated uniformly as "not
        // authenticated" — see the auth spec's Error handling section.
        if (!cancelled) {
          setLocation("/login");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [setLocation]);

  if (!data) {
    return null;
  }

  return <AuthProvider value={data}>{children}</AuthProvider>;
}
